import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as FailIcon } from 'assets/images/fail.svg';
import { Footer } from 'components/Footer';
import { ERoute, ESearchParams } from 'common/const';
import { useSearchParamsHook } from 'common/hooks/useSearchParamsHook';

export const FailLayout: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { getSearchParam } = useSearchParamsHook();

  const uuid = getSearchParam(ESearchParams.UUID);

  const onTryAgainClick = () => {
    navigate(`${ERoute.Payment}?${ESearchParams.UserId}=${uuid}`, { replace: true });
  };

  return (
    <div className="fail-layout">
      <div className="fail-layout__container">
        <FailIcon />

        <div className="fail-layout__label">{t('fail.label')}</div>

        <div className="fail-layout__description">
          <span>{t('fail.operationWasFailed')}</span>

          <span>{t('fail.pleaseTryAgain')}</span>
        </div>
      </div>

      {uuid && (
        <div className="btn btn-submit">
          <button onClick={onTryAgainClick}>{t('fail.tryAgain')}</button>
        </div>
      )}

      <Footer />
    </div>
  );
};
